import './styles.css'

export const ContentContainer: React.FC<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ children }) => <div className="content-container">{children}</div>
